

import { Component, Vue } from "vue-property-decorator"

@Component({
	components: {
		"page": () => import("@/components/Page.vue"),
		"subscription-card": () =>
			import("@/components/Organization/SubscriptionCard.vue")
	}
})
export default class Organization extends Vue {
	/**
	 * On mount, get organization page.
	 */
	public mounted (): void {
	}
}

